<template>
    <div style="background:#ea3d2c">
        <div style="width:1400px; margin:0 auto; padding:10px 0;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}" style="color:#fff">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="unohome_ctrl_container unohome">
            <div class="overview">
                <div class="unohome_block">
                    <h2>全球充值及运营情况(含美国)</h2>
                    <div class="board">
                        <div class="board-item" v-for="(block, b_index) in datas.common.fields" :key="b_index">
                            <ul class="board-left">
                                <li v-for="field in block" :style="{width:field.width}" :key="field.id"> {{field.title}}</li>
                            </ul>
                            <ul class="board-right">
                                <li v-for="field in block" :key="field.id">{{ datas.common.data[field.id]}}</li>
                            </ul>
                            </div>
                        </div>
                    <div class="tips">{{datas.common.time}}</div>
                </div>
                <div class="unohome_block" style="margin-top:20px">
                    <h2>美国充值收入</h2>
                    <div class="prepaid">
                        <div class="prepaid-item"><span class="title">今日：</span><span>{{datas.prepaid.total['day'] || '-'}}</span></div>
                        <div class="prepaid-item"><span class="title">昨日：</span><span>{{datas.prepaid.total['yesterday'] || '-'}}</span></div>
                        <div class="prepaid-item"><span class="title">本月：</span><span>{{datas.prepaid.total['month'] || '-'}}</span></div>
                        <div class="prepaid-item"><span class="title">累积：</span><span>{{datas.prepaid.total['history'] || '-'}}</span></div>
                    </div>
                    <div class="prepaid-channel">
                        <ul class="prepaid-channel-item" v-for="(channel_name,channel) in datas.prepaid.channels" :key="channel">
                        <li class="prepaid-channel-item-title">{{channel_name}}</li>
                        <li><span class="title">今日：</span><span>{{datas.prepaid.data[channel]['day']}}</span></li>
                        <li><span class="title">昨日：</span><span>{{datas.prepaid.data[channel]['yesterday']}}</span></li>
                        <li><span class="title">本月：</span><span>{{datas.prepaid.data[channel]['month']}}</span></li>
                        <li><span class="title">本年度：</span><span>{{datas.prepaid.data[channel]['year']}}</span></li>
                        <li><span class="title">累积：</span><span>{{datas.prepaid.data[channel]['history']}}</span></li>
                        </ul>
                    </div>
                    <div class="tips">{{datas.prepaid.time}}</div>
                </div>
                <!-- 表格 -->
                <div class="unohome_block" style="margin-top:30px" v-for="(it,index) in datas.results" :key="`table${index}`" >
                    <div class="table_title">
                        <h3>{{ it.title }}</h3>
                    </div>
                    <DataTable :fields="it.fields" :theads="it.theads" :datas="it.tbody" class="unohome_ctrl_table" :paging="false"/>
                    <div class="tips">
                        <p v-for="t in it.tips" :key="t">{{ t }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import DataTable from '@/components/common/datatable.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'unohome',
    props: ['parent', 'name'],
    components: {
        DataTable,
    },
    mounted(){
        this.getData()
    },
    data() {
        return {
            datas: {
                common: {},
                prepaid: {},
                results: [],
            },
        }
    },
    methods: {
        getData() {
            this.loading = true
            this.$service.query(this.queryId, {}).then((data)=>{
                data.results.forEach((table)=>{
                    let conf = this.get_multiple(table.thead)
                    table.theads = conf[0]
                    table.fields = conf[1]
                })
                this.datas = data
                this.loading = false
            }).catch((data)=> {
                this.loading = false
            })
        },
        get_multiple(multiplefields) {
            let theads = []
            let newfields = []
            let sub_index = 0
            if(multiplefields.length>0) {
                multiplefields[0].forEach((f)=>{
                    let field = Object.assign({}, f)
                    if(f['tooltip'])
                        field['desc'] = f['tooltip']
                    
                    if(!f['colspan']) {
                        theads.push(field)
                        newfields.push(field)
                    }
                    else {
                        field['children'] = []
                        if(multiplefields.length>=2) {
                            for(let index=sub_index; index<sub_index + f['colspan']; index+=1) {
                                let f2 = multiplefields[1][index]
                                let field2 = Object.assign({}, f2)
                                let field22 = Object.assign({}, f2)
                                field22['title']  = f['title']+f2['title']
                                if(f2['tooltip']) {
                                    field2['desc'] = f2['tooltip']
                                    field22['desc'] = f2['tooltip']
                                }
                                field['children'].push(field2)
                                newfields.push(field22)
                            }
                        }
                        sub_index+=f['colspan']
                        theads.push(field)
                    }
                })
                if(multiplefields.length>=2 && sub_index<multiplefields[1].length-1) {
                    for(let index = sub_index+1; index<multiplefields[1].length; index+=1) {
                        let f2 = multiplefields[1][index]
                        let field2 = Object.assign({}, f2)
                        let field22 = Object.assign({}, f2)
                        if(f2['tooltip']) {
                            field2['desc'] = f2['tooltip']
                            field22['desc'] = f2['tooltip']
                        }
                        newfields.push(field22)
                    }
                }
            }
            return [theads, newfields]
        },
    }
}
</script>
<style lang="less">
.unohome_ctrl_table {
    background:#fff;
    
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
        padding:5px 0;
        font-size:12px;
        background: #008b9e;
        color:#fff;
    }
    .ant-table-tbody > tr:nth-child(2n) td{
        background:#b3e9f1;
    }
    .ant-table-tbody > tr:hover td{
        background:#e6f7ff;
    }
    .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
        padding: 5px 0px;
        font-size:13px;
    }
}
</style>
<style lang="less">
.unohome_ctrl_container {
    @mainColor: #8c9ac1;
    background: #2cbace url('../../../assets/img/ctrl/uno/bg.jpg') center -40px no-repeat;
    width:100%;
    margin:0 auto;
    overflow: hidden;
    padding:250px 0 20px 0;

    .unohome_block {
        position: relative;
        width:1400px;
        margin:0 auto;
        text-align: center;
        h2 {
            color:#fad03e;
            font-size:30px;
            font-weight: bold;
            text-shadow: 1px 1px 2px #000;
        }
        h3 {
            position: relative;
            color:#fff;
            font-size:24px;
            font-weight: bold;
            margin:0 0 30px 0;
            &:before, &:after {
                content: "";
                position: absolute;
                top: 50%;
                border-bottom: 1px solid #fff;
                width: 500px;
            }
            
            &:before { right: 0; }
            &:after { left: 0; }
        }
        .tips {
            margin:10px 0;
            color:#fff;
        }
    }
    .board {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    max-width: 1000px;
    margin:0 auto;
    padding: 50px 25px 30px;
    border: 5px solid #4ca2af;
    background: rgba(255, 255, 255, 0.7);
    &:before {
        content: "";
        position: absolute;
        width: 1000px;
        height: 140px;
        left: 0;
        margin-left: 20px;
        top: -100px;
        background: url('../../../assets/img/ctrl/uno/logo.png') no-repeat;
        z-index: 1;
    }
    }

    .board-item{height:150px; background:#fff;}
    .board-left li, .board-right li{height:40px; line-height:40px;}
    .board-left{height:150px; padding:15px 15px;  background:#0fb4cc; color:#fff; text-align:right; float:left}
    .board-right{width:100px; padding:15px 15px;  float:right}

    .prepaid {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    max-width: 1000px;
    margin: 0px auto;
    padding: 20px;
    border: 5px solid #4ca2af;
    background: rgba(255, 255, 255, 0.7);
    &:before {
        content: "";
        position: absolute;
        width: 1000px;
        height: 100px;
        left: 0;
        margin-left: 20px;
        top: -100px;
        background: url(/static/img/uno/title_2.png) center no-repeat;
        z-index: 1;
    }
    }
    .prepaid-item{display: inline-block; width:25%; text-align: center; font-size:20px; color:#004a54}
    .prepaid-item span{font-weight: bold}

    .prepaid-channel{width:1000px; margin:20px auto; overflow: hidden}
    .prepaid-channel-item{width:250px; float:left; margin:0 0 0 125px; }
    .prepaid-channel-item:first-child{margin:0;}
    .prepaid-channel-item li{height:30px; line-height: 30px; background:#b3e9f1}
    .prepaid-channel-item li:nth-child(2n){background:#fff}
    .prepaid-channel-item li.prepaid-channel-item-title{background:#008b9e;color:#fff; text-align: center}
    .prepaid-channel-item li span{padding:0 20px; width:125px;  display:inline-block;}
    .prepaid-channel-item li span.title{text-align: right;}
}
</style>